module.exports = __webpack_public_path__ + "img/globalOwners.463f4cac.svg";